import { Link } from 'react-router-dom'

import { Navigation20Regular } from '@fluentui/react-icons'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { styled, css, keyframes } from '@styles/theme'

const slideUpAndFade = keyframes({
	'0%': { opacity: 0, transform: 'translateY(2px)' },
	'100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideRightAndFade = keyframes({
	'0%': { opacity: 0, transform: 'translateX(-2px)' },
	'100%': { opacity: 1, transform: 'translateX(0)' },
})

const slideDownAndFade = keyframes({
	'0%': { opacity: 0, transform: 'translateY(-2px)' },
	'100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideLeftAndFade = keyframes({
	'0%': { opacity: 0, transform: 'translateX(2px)' },
	'100%': { opacity: 1, transform: 'translateX(0)' },
})

export const headerStyles = {
	header: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '80px',
		position: 'relative',
		zIndex: '400',
	}),
	container: css({
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		height: '80px',
		position: 'fixed',
		padding: '0px 24px',
		background: '$neutral10',
		boxShadow: '1px 1px 7px -2px rgba(0, 0, 0, 0.13)',

		'@sm': {
			padding: '0px 24px 0px 24px',
		},

		'@md': {
			padding: '0px 64px 0px 24px',
			borderBottom: '1px solid $neutral40',
			boxShadow: 'unset',
		},
	}),
	sidebar: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		gap: '8px',

		svg: {
			cursor: 'pointer',
			color: '$neutral90',
		},

		'@sm': {
			justifyContent: 'space-between',
			maxWidth: '190px',
		},
	}),
	NavigationIcon: styled(Navigation20Regular, {
		cursor: 'pointer',
		color: '$neutral90',
		width: '32px',
		height: '32px',

		'@sm': {
			justifyContent: 'space-between',
			width: '22px',
			height: '19px',
		},
	}),
	LinkIndex: styled(Link, {
		margin: '0 auto',
		'@sm': {
			margin: '0px',
		},
	}),
	person: css({
		display: 'flex',
		svg: {
			cursor: 'pointer',
			color: '$neutral90',
		},

		'@sm': {
			gap: 32,
			alignItems: 'center',
		},
	}),
	personInfo: css({
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		cursor: 'pointer',
	}),

	DropdownMenuItem: styled(DropdownMenu.Item, {
		all: 'unset',
		_font: 'normal',
		fontSize: '$lg',
		lineHeight: '19px',
		color: '$neutral100',
		borderRadius: 3,
		display: 'flex',
		gap: '8px',
		alignItems: 'center',
		height: 25,
		padding: '0px',
		userSelect: 'none',
		cursor: 'pointer',
		svg: {
			width: '20px',
			height: '20px',
		},
		'&[data-disabled]': {
			pointerEvents: 'none',
		},

		'&[data-highlighted]': {
			/* 	  backgroundColor: violet.violet9,
		  color: violet.violet1, */
		},
		'&:hover': {
			color: '$blue20',
		},
	}),

	DropdownMenuContent: styled(DropdownMenu.Content, {
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
		width: '200px',
		background: '$neutral10',
		zIndex: '400',
		borderRadius: '12px',
		padding: 32,
		boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
		animationDuration: '400ms',
		animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
		willChange: 'transform, opacity',
		'&[data-state="open"]': {
			'&[data-side="top"]': { animationName: slideDownAndFade },
			'&[data-side="right"]': { animationName: slideLeftAndFade },
			'&[data-side="bottom"]': { animationName: slideUpAndFade },
			'&[data-side="left"]': { animationName: slideRightAndFade },
		},
	}),

	DropdownMenuPortal: styled(DropdownMenu.Portal, {}),
	DropdownMenuRoot: styled(DropdownMenu.Root, {}),
}
